import React from 'react';
import { Box, Flex } from 'rebass/styled-components';

import { VerifyEmail as VerifyEmailComponent } from '../../../../components/molecules/verifyEmail';

export const VerifyEmail = () => (
  <Flex bg="neutral.0" sx={{ gap: '24px', boxShadow: 'medium', borderRadius: 'default', overflow: 'hidden' }}>
    <Box p="40px" width="600px">
      <Box maxWidth="520px" mx="auto">
        <VerifyEmailComponent />
      </Box>
    </Box>
  </Flex>
);
